module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-BookOblique.4615524e.woff";